export default __webpack_public_path__ + "static/dotinx_logo-a259ec0b4a6c5fcf403997c68bbdf71e.svg";